import Vue from 'vue';
import Router from 'vue-router';

import Login from "@/pages/Login"; //登录页面

import Home from '@/pages/Home'; //主页
import Notice from '@/pages/Notice'; //通知公告
import LetterAdmission from '@/pages/LetterAdmission'; //录取通知书

// 学生信息
import UserInfo from "@/pages/user/UserInfo"; //个人信息
import StudentPhoto from "@/pages/user/StudentPhoto"; //学籍照片上传
import StudentCard from "@/pages/user/StudentCard"; //学籍卡
import RegistrationForm from "@/pages/user/RegistrationForm"; //毕业生登记表
import MyNews from "@/pages/user/MyNews"; //我的消息
import GraduatePhoto from "@/pages/user/GraduatePhoto"; //毕业照片上传
import EditPassword from "@/pages/user/EditPassword"; //修改密码
import StudentReport from "@/pages/user/studentReport"; //新生报到
import StudentReportHevttc from "@/pages/user/studentReport_hevttc"; //新生报到（hevttc 学校专用）
import TemplateInfo from "@/pages/user/TemplateInfo"; //新生报到
import LinkTemplateInfo from "@/pages/user/linkTemplateInfo"; //学籍异动
import MaterialUpload from "@/pages/user/MaterialUpload"; //材料上传
//资料下载
import DataDownload from "@/pages/DataDownload"; //资料下载

//成绩查询
import ScoreQuery from "@/pages/ScoreQuery"; //成绩查询

//补考安排
import MakeUpExam from "@/pages/MakeUpExam"; //补考安排

//报到材料
import CheckInMaterials from "@/pages/CheckInMaterials"; //报到材料

//选课中心
import CourseSelection from "@/pages/CourseSelection"; //选课中心
import CourseSelectionCenter from "@/pages/courseSelection/listView"; //选课中心【新】

//教学计划
import TeachingPlan from "@/pages/teachingPlan/TeachingPlan"; //教学计划
import TimetableQuery from "@/pages/teachingPlan/TimetableQuery"; //课表查询

//在线缴费
import Pay from "@/pages/onlinePayment/Pay"; //在线缴费
import ExpenseQuery from "@/pages/onlinePayment/ExpenseQuery"; //费用查询
import Voucher from "@/pages/onlinePayment/Voucher"; //缴费凭证上传
import StudentPayQRCode from "@/pages/onlinePayment/StudentPayQRCode"; //缴费二维码

//毕业论文
import Instructor from "@/pages/dissertation/Instructor"; //论文指导老师
import PaperScoreQuery from "@/pages/dissertation/PaperScoreQuery"; //论文成绩查询
import UserPaper from "@/pages/dissertation/UserPaper"; //我得论文
import PaperUpload from "@/pages/dissertation/PaperUpload"; //论文上传
import Require from "@/pages/dissertation/Require"; //论文要求查看
import TopicSetting from "@/pages/dissertation/TopicSetting"; //论文题目设置

//学习中心
import OnlineLearning from "@/pages/learningCenter/OnlineLearning"; //在线学习
import PreschoolTutoring from "@/pages/learningCenter/PreschoolTutoring"; //在线学习
import LiveClass from "@/pages/learningCenter/LiveClass"; //直播课
import StartLearning from "@/pages/learningCenter/StartLearning";//开始学习
import StudyAuthentication from "@/pages/learningCenter/StudyAuthentication";//学习认证
import SchoolAssignment from "@/pages/learningCenter/SchoolAssignment";//作业
import JobRecord from "@/pages/learningCenter/JobRecord";//作业记录
import WrongQuestion from "@/pages/learningCenter/WrongQuestion";//错题本
import WrongExercise from "@/pages/learningCenter/WrongExercise";//错题练习
import Examination from "@/pages/learningCenter/Examination";//作业考试
import ViewAnswerSheet from "@/pages/learningCenter/ViewAnswerSheet";//作业考试 （查看答案）
import ViewAnswerSheetExam from "@/pages/learningCenter/exam/ViewAnswerSheetExam";//考试 （查看答案）
import ExamList from "@/pages/learningCenter/exam/ExamList";//考试列表
import ExamInfo from "@/pages/learningCenter/exam/Examination";//考试
import PutQuestions from "@/pages/learningCenter/PutQuestions";
import MakeUpExamList from "@/pages/learningCenter/exam/MakeUpExamList";//考试列表
import {getCookieForRoleTag, getQueryVariable, getTokenForRoleTag} from "../common/ulit";
import fa from "element-ui/src/locale/lang/fa";
//提问

//直播计划
import LivePlan from "@/pages/live/livePlan";//直播
import LiveCourse from "@/pages/live/LiveCourse"; //直播课
//import LivePlan from '@/pages/Notice';

import QuestionnaireList from "@/pages/questionnaire/QuestionnaireList"; //问卷调查列表
import TeacherEvaluateList from "@/pages/teacherEvaluate/TeacherEvaluateList"; //教师评价列表
import TeacherEvaluateView from "@/pages/teacherEvaluate/TeacherEvaluateView"; //教师评价详情
import MyFinances from "@/pages/myFinances";//我的财务
//成交论文
import ask from  "@/pages/transactionPaper/ask"; //论文要求列表
import application from  "@/pages/transactionPaper/application"; //论文报名
import write from  "@/pages/transactionPaper/write"; //论文写作
import finalUpload from  "@/pages/transactionPaper/finalUpload"; //上传终稿
import check from  "@/pages/transactionPaper/check"; //论文查重
//查重
import duplicateCheck from "@/pages/transactionPaper/duplicateCheck"; //查重

//论文AI评审
import reviewArticle from "@/pages/transactionPaper/reviewArticle"; //论文AI评审

import stuStatusChangeApply from  "@/pages/statusChange/stuStatusChangeApply"; //学籍异动

// 请假申请
import leaveApply from "@/pages/leaveApply/leaveApply"; //请假申请

// 任务分组
import taskGrouping from "@/pages/taskGrouping/taskGrouping"; //任务分组
import DegreeApplication from "@/pages/DegreeApplication"; //学位申请

import InternshipManagement from "@/pages/InternshipManagement"; //实习管理
import CourseRetake from "@/pages/CourseRetake"; //重修申请
import OnlineDefenseList from "@/pages/onlineDefense/OnlineDefenseList"; //在线答辩
import OnlineDefenseDetail from "@/pages/onlineDefense/OnlineDefenseDetail"; //在线答辩详情

// 在线答辩
import OnlineDefense from "@/pages/onlineDefense/OnlineDefense"; //在线答辩

// 专升本资格审查
import AddReviewProgram from "@/pages/addReviewProgram/index.vue"; //专升本资格审查



Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login/',
            name: 'Login',
            component: Login,
            meta: {title: '登录', requireAuth: false, menuShow: false, headerShow: false}
        },
        /** 2023-07-26 修改首页直接跳转学习中心 邯郸学院已经部署 */
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {title: '首页', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/home/',
            name: 'Home_',
            component: Home,
            meta: {title: '首页', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/notice/',
            name: 'Notice',
            component: Notice,
            meta: {title: '通知公告', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/letterAdmission/',
            name: 'LetterAdmission',
            component: LetterAdmission,
            meta: {title: '录取通知书', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/dataDownload/',
            name: 'DataDownload',
            component: DataDownload,
            meta: {title: '资料下载', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/scoreQuery/',
            name: 'ScoreQuery',
            component: ScoreQuery,
            meta: {title: '论文成绩查询', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/makeUpExam/',
            name: 'MakeUpExam',
            component: MakeUpExam,
            meta: {title: '补考安排', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/checkInMaterials/',
            name: 'CheckInMaterials',
            component: CheckInMaterials,
            meta: {title: '报到材料', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/courseSelection/',
            name: 'CourseSelection',
            component: CourseSelection,
            meta: {title: '选课中心', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/CourseSelectionCenter/',
            name: 'CourseSelectionCenter',
            component: CourseSelectionCenter,
            meta: {title: '选课中心', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/userInfo/',
            name: 'UserInfo',
            component: UserInfo,
            meta: {title: '个人信息', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/studentPhoto/',
            name: 'StudentPhoto',
            component: StudentPhoto,
            meta: {title: '学籍照片上传', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/studentCard/',
            name: 'StudentCard',
            component: StudentCard,
            meta: {title: '学籍卡', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/registrationForm/',
            name: 'RegistrationForm',
            component: RegistrationForm,
            meta: {title: '毕业生登记表', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/myNews/',
            name: 'MyNews',
            component: MyNews,
            meta: {title: '我的消息', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/graduatePhoto/',
            name: 'GraduatePhoto',
            component: GraduatePhoto,
            meta: {title: '毕业照片上传', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/editPassword/',
            name: 'EditPassword',
            component: EditPassword,
            meta: {title: '修改密码', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/teachingPlan/',
            name: 'TeachingPlan',
            component: TeachingPlan,
            meta: {title: '教学计划', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/timetableQuery/',
            name: 'TimetableQuery',
            component: TimetableQuery,
            meta: {title: '课表查询', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/pay/',
            name: 'Pay',
            component: Pay,
            meta: {title: '在线缴费', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/expenseQuery/',
            name: 'ExpenseQuery',
            component: ExpenseQuery,
            meta: {title: '费用查询', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/voucher/',
            name: 'Voucher',
            component: Voucher,
            meta: {title: '缴费凭证上传', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/instructor/',
            name: 'Instructor',
            component: Instructor,
            meta: {title: '论文指导老师', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/paperScoreQuery/',
            name: 'PaperScoreQuery',
            component: PaperScoreQuery,
            meta: {title: '论文成绩查询', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/userPaper/',
            name: 'UserPaper',
            component: UserPaper,
            meta: {title: '我的论文', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/PaperUpload/',
            name: 'PaperUpload',
            component: PaperUpload,
            meta: {title: '论文上传', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/require/',
            name: 'Require',
            component: Require,
            meta: {title: '论文要求查看', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/topicSetting/',
            name: 'TopicSetting',
            component: TopicSetting,
            meta: {title: '论文题目设置', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/onlineLearning/',
            name: 'OnlineLearning',
            component: OnlineLearning,
            meta: {title: '在线学习', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/liveClass/',
            name: 'LiveClass',
            component: LiveClass,
            meta: {title: '直播课', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/preschoolTutoring/',
            name: 'PreschoolTutoring',
            component: PreschoolTutoring,
            meta: {title: '学前辅导', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/startLearning/',
            name: 'StartLearning',
            component: StartLearning,
            meta: {title: '开始学习', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/studyAuthentication/',
            name: 'StudyAuthentication',
            component: StudyAuthentication,
            meta: {title: '学习认证', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/schoolAssignment/',
            name: 'SchoolAssignment',
            component: SchoolAssignment,
            meta: {title: '作业', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/jobRecord/',
            name: 'JobRecord',
            component: JobRecord,
            meta: {title: '作业记录', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/wrongQuestion/',
            name: 'WrongQuestion',
            component: WrongQuestion,
            meta: {title: '错题本', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/wrongExercise/',
            name: 'WrongExercise',
            component: WrongExercise,
            meta: {title: '错题练习', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/examination/',
            name: 'Examination',
            component: Examination,
            meta: {title: '作业考试', requireAuth: true, menuShow: false, headerShow: false}
        },
        {
            path: '/viewAnswerSheet/',
            name: 'ViewAnswerSheet',
            component: ViewAnswerSheet,
            meta: {title: '查看答卷', requireAuth: true, menuShow: false, headerShow: false}
        },
        {
            path: '/viewAnswerSheetExam/',
            name: 'ViewAnswerSheetExam',
            component: ViewAnswerSheetExam,
            meta: {title: '查看考试答卷', requireAuth: true, menuShow: false, headerShow: false}
        },
        {
            path: '/examList/',
            name: 'ExamList',
            component: ExamList,
            meta: {title: '考试列表', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/examInfo/',
            name: 'ExamInfo',
            component: ExamInfo,
            meta: {title: '考试', requireAuth: true, menuShow: false, headerShow: false}
        },
        {
            path: '/putQuestions/',
            name: 'PutQuestions',
            component: PutQuestions,
            meta: {title: '提问', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/makeUpExamList',
            name: 'MakeUpExamList',
            component: MakeUpExamList,
            meta: {title: '补考列表', requireAuth: true, menuShow: false, headerShow: true}
        },
        {
            path: '/studentReport/',
            name: 'StudentReport',
            component: StudentReport,
            meta: {title: '新生报道', requireAuth: true, menuShow: true, headerShow: true},
        },
        {
            path: '/StudentReportHevttc/',
            name: 'StudentReportHevttc',
            component: StudentReportHevttc,
            meta: {title: '入学资格审查', requireAuth: true, menuShow: true, headerShow: true},
        },
        {
            path: '/templateInfo/',
            name: 'TemplateInfo',
            component: TemplateInfo,
            meta: {title: '我的信息', requireAuth: true, menuShow: true, headerShow: true},
        },
        {
            path: '/linkTemplateInfo/',
            name: 'LinkTemplateInfo',
            component: LinkTemplateInfo,
            meta: {title: '异动信息', requireAuth: true, menuShow: true, headerShow: true},
        },
        {
            path: '/live/',
            name: 'LivePlan',
            component: LivePlan,
            meta: {title: '直播计划', requireAuth: true, menuShow: true, headerShow: true}
        },

        {
            path: '/LiveCourse/',
            name: 'LiveCourse',
            component: LiveCourse,
            meta: {title: '直播课', requireAuth: true, menuShow: true, headerShow: true}
        },

        {
            path: '/questionnaireList/',
            name: 'QuestionnaireList',
            component: QuestionnaireList,
            meta: {title: '问卷列表', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/myFinances/',
            name: 'MyFinances',
            component: MyFinances,
            meta: {title: '我的财务', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/teacherEvaluateList/',
            name: 'TeacherEvaluateList',
            component: TeacherEvaluateList,
            meta: {title: '教师评价列表', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/teacherEvaluateView/',
            name: 'TeacherEvaluateView',
            component: TeacherEvaluateView,
            meta: {title: '教师评价详情', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/teacherEvaluateList/',
            name: 'TeacherEvaluateList',
            component: TeacherEvaluateList,
            meta: {title: '教师评价列表', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/teacherEvaluateView/',
            name: 'TeacherEvaluateView',
            component: TeacherEvaluateView,
            meta: {title: '教师评价详情', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/ask/',
            name: 'ask',
            component: ask,
            meta: {title: '论文要求', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/application/',
            name: 'application',
            component: application,
            meta: {title: '论文报名', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/write/',
            name: 'write',
            component: write,
            meta: {title: '论文写作', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/finalUpload/',
            name: 'finalUpload',
            component: finalUpload,
            meta: {title: '上传终稿', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/check/',
            name: 'check',
            component: check,
            meta: {title: '论文写作', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/stuStatusChangeApply/',
            name: 'stuStatusChangeApply',
            component: stuStatusChangeApply,
            meta: {title: '学籍异动', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/duplicateCheck/',
            name: 'duplicateCheck',
            component: duplicateCheck,
            meta: {title: '查重', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/reviewArticle/',
            name: 'reviewArticle',
            component: reviewArticle,
            meta: {title: '评文AI评审', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/leaveApply',
            name: 'leaveApply',
            component: leaveApply,
            meta: {title: '请假申请', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/taskGrouping',
            name: 'taskGrouping',
            component: taskGrouping,
            meta: {title: '任务分组', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/degreeApplication/',
            name: 'DegreeApplication',
            component: DegreeApplication,
            meta: {title: '学位申请', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/studentPayQRCode/',
            name: 'StudentPayQRCode',
            component: StudentPayQRCode,
            meta: {title: '缴费', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/materialUpload/',
            name: 'MaterialUpload',
            component: MaterialUpload,
            meta: {title: '材料上传', requireAuth: true, menuShow: true, headerShow: true}
        }, {
            path: '/addReviewProgram/',
            name: 'AddReviewProgram',
            component: AddReviewProgram,
            meta: {title: '专升本资格审查', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/internshipManagement/',
            name: 'InternshipManagement',
            component: InternshipManagement,
            meta: {title: '实习管理', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/courseRetake/',
            name: 'CourseRetake',
            component: CourseRetake,
            meta: {title: '重修申请', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/onlineDefense/',
            name: 'OnlineDefense',
            component: OnlineDefense,
            meta: {title: '在线答辩', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/onlineDefense/',
            name: 'OnlineDefenseList',
            component: OnlineDefenseList,
            meta: {title: '在线答辩', requireAuth: true, menuShow: true, headerShow: true}
        },
        {
            path: '/onlineDefense/detail/',
            name: 'OnlineDefenseDetail',
            component: OnlineDefenseDetail,
            meta: {title: '在线答辩详情', requireAuth: true, menuShow: true, headerShow: true}
        },
    ]
});

router.beforeEach((to, from, next) => {


    if (to.meta.menuShow == false) { //根据是否显示左侧菜单栏是否修改页头标题
        window.document.title = to.meta.title == undefined ? '首页' : to.meta.title
    }

    // 是否需要登录
    if (to.matched.some(m => m.meta.requireAuth)) {
        const self = Vue.prototype;
        if (getCookieForRoleTag()) {
            if (from.query["_role_tag"] !== undefined && to.query["_role_tag"] === undefined) {
                to.query["_role_tag"] = from.query["_role_tag"];
                next(to);
                return;
            }
            next();
        } else {
            window.location.href = process.env.NODE_ENV === "development" ? '/login' : self.$baseUrl + '/login';
            // window.location.href = window.location.origin + '/Login';
        }
    } else {
        if (from.query["_role_tag"] !== undefined && to.query["_role_tag"] === undefined) {
            to.query["_role_tag"] = from.query["_role_tag"];
            next(to);
            return;
        }
        next();
    }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js